export default __webpack_public_path__ + "static/media/wib_peoople_text.50653022.svg";